{
  "title": "Word of Radiance",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "Evocation cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "5 feet",
  "components": "V, M (a holy symbol)",
  "duration": "Instantaneous",
  "description": [
    "You utter a divine word, and burning radiance erupts from you. Each creature of your choice that you can see within range must succeed on a Constitution saving throw or take 1d6 radiant damage.",
    "At Higher Levels. The spell’s damage increases by 1d6 when you reach 5th level (2d6), 11th level (3d6), and 17th level (4d6)."
  ],
  "spellLists": ["cleric"]
}
